<script>
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import formatPhone from "@shared/filters/phone.js";
  import { url } from "@roxi/routify";

  export let employee;
</script>

<div
  class="fizz-card fizz-card-interactive fizz-bordered cursor-pointer box-shadow--hover"
  id="sales_rep_{employee.ids[0]}"
>
  <a
    href={$url("/distributor/sales_reps/:salesRepId", {
      salesRepId: employee.ids[0],
    })}
    class="fizz-overlay-link fizz-text-inherit fizz-underline-none"
  >
    <div class="fizz-inset-square-8 fizz-flex-row fizz-space-between">
      <span class="fizz-text-strong">{employee.names[0]}</span>
      <div class="fizz-text-right">
        <Icon type={"ArrowRight"} extraClassNames={"fizz-icon-16"} />
      </div>
    </div>
    <div class="grid-row"><hr class="hr hr-card-separator--header" /></div>
    <div class="fizz-flex-row fizz-inset-square-8">
      <div>{employee.contact_email || "--"}</div>
    </div>
    <div class="fizz-flex-row fizz-inset-square-8 fizz-space-between">
      <div>{formatPhone(employee.contact_phone)}</div>
      <div class="fizz-text-right">{employee.retailer_count} Retailers</div>
    </div>
  </a>
</div>
